import CreateRules from "../../views/carriersRules/components/CreateRuleMain.vue";

const createRulesRoute = [
  {
    path: "/createRules/:ruleId?/:profileId?",
    name: "CreateRules",
    component: CreateRules,
  },
];

export default createRulesRoute;
